import { Icon } from '@iconify/react'
import { Collapse, Panel } from '@pepper/ui'

import { Faq } from '@pepper/utils/src/types/seo'

import s from './FAQs.module.css'

type Props = {
  questions: Faq[]
}

const FAQs = ({ questions }: Props) => {
  return (
    <Collapse expandIconPosition="right" className={s.wrapper}>
      {questions.map(question => {
        return (
          <Panel
            header={
              <div className={s.question}>
                <Icon
                  icon="uil:comment-alt-question"
                  width="16"
                  className={s.questionIcon}
                />
                {question.question}
              </div>
            }
            key={question.question}
            className={s.accordion}
          >
            <div className={s.answer}>
              {question.snippet}&nbsp;
              <a target="_blank" rel="noreferrer noopener" href={question.link}>
                Read more
              </a>
            </div>
          </Panel>
        )
      })}
    </Collapse>
  )
}

export default FAQs
